import React from 'react';
import { Box, CircularProgress, Typography } from '@mui/material';

interface LoaderProps {
  message?: string;
  fullHeight?: boolean;
}

export const Loader: React.FC<LoaderProps> = ({ message = 'Loading...', fullHeight = false }) => {
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        gap: 2,
        height: fullHeight ? '100vh' : 'auto',
        padding: 2,
      }}
    >
      <CircularProgress />
      {message && <Typography variant="body2">{message}</Typography>}
    </Box>
  );
};
